// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_d0-b";
export var colorBlue = "_d0-8";
export var colorDot = "_d0-0";
export var colorDotLarge = "_d0-2";
export var colorDotSmall = "_d0-1";
export var colorGreen = "_d0-7";
export var colorGrey = "_d0-3";
export var colorOrange = "_d0-5";
export var colorPink = "_d0-a";
export var colorPurple = "_d0-9";
export var colorRed = "_d0-4";
export var colorYellow = "_d0-6";